import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {

  addProductCategories,
  deleteProductCategories,
  duplicateProductCategories,
  fetchProductCategories,
  renameProductCategories,
  updateSortingType,
} from "./actions";
import { CustomListItem } from "@/utils/types/manageList";
import { debug } from "console";

interface ProductState {
  isLoading: boolean;
  isError: boolean;
  userData: UserData;
  itemsList: itemsList[];
  isAuthenticated:boolean;
  errorMessage: string;
  isListAdded: boolean;
}

interface itemsList {
  id?: number;
  name?: string;
}

interface UserData {
  userId: string;
  categoryId: string;
}

const initialState: ProductState = {
 
  isLoading: false,
  isError: false,
  errorMessage: "",
  userData: {
    userId: "",
    categoryId: ""
  },
  itemsList: [],
  isAuthenticated:false,
  isListAdded: false

};

const fallbackErrorMessage = "Something went wrong. Please try again."


export const ManageListingSlice = createSlice({
  name: "manageListSlice",
  initialState,
  reducers: {
    resetManageList: () => initialState, 

    setManageList: (state, action) => {
      if (!Array.isArray(state.itemsList)) {
        state.itemsList = [];
      }
      state.itemsList = [...state.itemsList, action.payload];
    },
    deleteManageList: (state, action) => {
      state.itemsList = state.itemsList.filter(
        (item) =>  item.id != action.payload
      );
    },
    duplicateManageList: (state, action) => {
      state.itemsList = [...state.itemsList, action.payload];
    },
    renameMangementList: (state, action) => {
      state.itemsList = state.itemsList.map((item: itemsList) => {
        if (item.id == action.payload.id) {
          return { ...item, name: action.payload.name };
        }
        return item;
      });
    },
    setUserData: (state, action) => {
      state.userData = action.payload;
    },

  
    resetUserData: (state) => {
      state.userData = { userId: "", categoryId: "" };
    },
   
    updateMangementList: (state, action) => {
      state.itemsList = state.itemsList.map((item: itemsList) => {
        if (item.id === action.payload.id) {
          return { ...item, sorting: action.payload.sortingType };
        }
        return item;
      });
    },

    setUsersManageList: (state, action) => {
      state.itemsList = action?.payload?.allList;
      state.isAuthenticated=true
    },
    updateManageListByStore: (state, action) => {
      return {
        ...state,
        ...action.payload
      };
    },

    setGuestListAdded:(state)=>{
      state.isAuthenticated=true;
    }
   

  },
  extraReducers: (builder) => {
    builder.addCase(fetchProductCategories.pending, (state: any) => {
      state.isLoading = true;
      state.isError = false;
    });
    builder.addCase(
      fetchProductCategories.fulfilled,
      (state: any, action: PayloadAction<any>) => {
        state.isLoading = false;
        state.isError = false;
        state.itemsList = action?.payload?.getListData;
        state.isAuthenticated=true
      }

    );
    builder.addCase(fetchProductCategories.rejected, (state: any, action) => {
      state.isLoading = false;
      state.isError = true;
      state.errorMessage = action?.payload ?? fallbackErrorMessage;

    });

    //add management list
    builder.addCase(addProductCategories.pending, (state: any) => {
      // state.isLoading = true;
      state.isError = false;
    });
    builder.addCase(
      addProductCategories.fulfilled,
      (state: any, action: PayloadAction<any>) => {
        const latestList = {
          id: action?.payload?.data?.id,
          name: action?.payload?.data?.name,
          is_active: action?.payload?.data?.is_active,
          sorting: action?.payload?.data?.sorting,
          createdAt: action?.payload?.data?.createdAt,
          updatedAt: action?.payload?.data?.updatedAt,
          // items:[] don't remove it
        };
        state.isLoading = false;
        state.isError = false;
        state.itemsList = [...state.itemsList, latestList];
        state.userData.userId = action?.payload?.data?.user_id
        state.isAuthenticated=true
      }
    );
    builder.addCase(addProductCategories.rejected, (state: any, action) => {
      state.isLoading = false;
      state.isError = true;
      state.errorMessage = action?.payload ?? fallbackErrorMessage;
    });

    //delete management list
    builder.addCase(deleteProductCategories.pending, (state: any) => {
      // state.isLoading = true;
      state.isError = false;
    });
    builder.addCase(
      deleteProductCategories.fulfilled,
      (state: any, action: PayloadAction<any>) => {
        const deletedId = action.payload.id;
        state.isLoading = false;
        state.isError = false;
        state.isAuthenticated=true
        state.itemsList = state.itemsList.filter(
          (list: { id: "string" }) => list?.id != deletedId
        );
      }
    );
    builder.addCase(deleteProductCategories.rejected, (state: any, action) => {
      state.isLoading = false;
      state.isError = true;
      state.errorMessage = action?.payload ?? fallbackErrorMessage;

    });

    //rename management list
    builder.addCase(renameProductCategories.pending, (state: any) => {
      // state.isLoading = true;
      state.isError = false;
    });
    builder.addCase(
      renameProductCategories.fulfilled,
      (state: any, action: PayloadAction<any>) => {
        // debugger
        state.isLoading = false;
        state.isError = false;
        state.isAuthenticated=true
        state.itemsList = state.itemsList.map((item: { id: "string" }) => {
          if (item.id == action.payload.id) {
            // If the item matches the id, update its name
            return { ...item, name: action.payload.name };
          }
          return item;
        });
      }
    );
    builder.addCase(renameProductCategories.rejected, (state: any, action) => {
      state.isLoading = false;
      state.isError = true;
      state.errorMessage = action?.payload ?? fallbackErrorMessage;
    });

    //duplicate management list
    builder.addCase(duplicateProductCategories.pending, (state: any) => {
      // state.isLoading = true;
      state.isError = false;
    });
    builder.addCase(
      duplicateProductCategories.fulfilled,
      (state: any, action: PayloadAction<any>) => {
        // debugger
        const duplicateList = {
          id: action?.payload?.data?.id,
          user_id: action?.payload?.data?.user_id,
          name: action?.payload?.data?.name,
          createdAt: action?.payload?.data?.createdAt,
          updatedAt: action?.payload?.data?.updatedAt,
          items: action?.payload?.items?.slice(0, 2),
        };

        state.isLoading = false;
        state.isError = false;
        if(action?.payload){
          state.itemsList = [...state.itemsList, duplicateList];
        }
        state.isAuthenticated=true
      }
    );
    builder.addCase(duplicateProductCategories.rejected, (state: any, action) => {
      state.isLoading = false;
      state.isError = true;
      state.errorMessage = action?.payload ?? fallbackErrorMessage;

    });

    //bulk insertion management list
    // builder.addCase(bulkInsertionProductCategories.pending, (state: any) => {
    //   state.isLoading = true;
    //   state.isError = false;
    // });
    // builder.addCase(bulkInsertionProductCategories.fulfilled, (state: any) => {
    //   state.isLoading = false;
    //   state.isError = false;
    //   state.isAuthenticated=true
    // });
    // builder.addCase(bulkInsertionProductCategories.rejected, (state: any, action) => {
    //   state.isLoading = false;
    //   state.isError = true;
    //   state.errorMessage = action?.payload ?? fallbackErrorMessage;

    // });


     //update sorting option for list
     builder.addCase(updateSortingType.pending, (state: any) => {
      state.isLoading = true;
      state.isError = false;
    });
    builder.addCase(
      updateSortingType.fulfilled,
      (state: any, action: PayloadAction<any>) => {
        state.isLoading = false;
        state.isError = false;
        state.isAuthenticated=true
        state.itemsList = state.itemsList.map((item: { id: "string" }) => {
          if (item.id === action.payload.id) {
            // If the item matches the id, update its name
            return { ...item, sorting: action.payload.sortingType };
          }
          return item;
        });
      }
    );
    builder.addCase(updateSortingType.rejected, (state: any, action) => {
      state.isLoading = false;
      state.isError = true;
      state.errorMessage = action?.payload ?? fallbackErrorMessage;
    });
  },
});

export const {

  setManageList,
  deleteManageList,
  duplicateManageList,
  renameMangementList,
  setUserData,
  resetUserData,
  resetManageList,
  updateMangementList,
  setUsersManageList,
  updateManageListByStore,
  setGuestListAdded
} = ManageListingSlice.actions;
export const manageListReducer = ManageListingSlice.reducer;
